import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { PermissionTypeEnum } from 'src/app/common/permission-enum';
import { getLongDate, getStringDate } from 'src/app/common/util';
import { ProductResponse } from 'src/app/models/product.model';
import { PurchaseResponse, PurchaseSeriesRequest, SeriesRequest, SeriesResponse } from 'src/app/models/purchase.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { VendorResponse } from 'src/app/models/vendor.model';
import { WarehouseResponse } from 'src/app/models/warehouse.model';
import { BillpayService } from 'src/app/services/billpay.service';
import { CaisService } from 'src/app/services/cais.service';
import { FiscalDocumentService } from 'src/app/services/fiscal-document.service';
import { ProductService } from 'src/app/services/product.service';
import { PurchasesService } from 'src/app/services/purchases.service';
import { WarehouseService } from 'src/app/services/warehouse.service';
import { ActivatedRoute } from '@angular/router';
import { QueryParamsArService } from 'src/app/services/query-params-ar.service';

@Component({
  selector: 'app-history-purchases',
  templateUrl: './history-purchases.component.html',
  styleUrls: ['./history-purchases.component.scss']
})
export class HistoryPurchasesComponent implements OnInit {
  permissionType = PermissionTypeEnum;
  startDate = '';
  endDate = '';
  type = 0;
  invoiceCheck = true;
  receiptCheck = true;
  searchVendor = "";
  invoiceDetail: any = null;
  warehouseId: number = 0;
  warehouse = null;
  @Input() warehouseNames: { [key: number]: WarehouseResponse } = [];
  @Input() warehouseList: WarehouseResponse[] = [];
  editing = false;
  isMoving = false;
  inputs = {
    warehouse: {
      value: null,
      verified: false,
      required: true,
      message: 'Campo requerido',
      class: 'fa-asterisk',
      color: 'danger',
      tooltip: 'status-warehouse',
      data: {
        id: null
      }
    },
    product: {
      value: null,
      verified: false,
      required: true,
      message: 'Campo requerido',
      class: 'fa-asterisk',
      color: 'danger',
      tooltip: 'status-warehouse',
      data: {
        id: null
      }
    }
  };
  timeout = null;
  transforming = false;
  isModalSeriesShowed = false;

  newPurchase: PurchaseResponse = new PurchaseResponse();
  purchases: PurchaseResponse[] = [];

  deleting: { [key: string]: boolean } = {};
  detailing: { [key: string]: boolean } = {};
  moving: { [key: string]: boolean } = {};
  gettingProducts: { [key: string]: boolean } = {};
  loadedDetail: { [key: number]: boolean } = {};
  isAscendent = 0;
  waitingFor = null;
  warehouses = [];
  filterWarehouses = [];
  productToTransform = null;
  products = [];
  filterProducts = [];
  todayDate = new Date();
  pagination = {
    total: [],
    filter: [],
    pageSize: 5,
    startElement: 0,
    lastElement: 0,
    pageIndex: 0
  }
  total = 0;
  newPurchaseSerie = new PurchaseSeriesRequest();
  productToAddSerie = null;
  productsIds: { [key: string]: any } = {}
  warehousesById: { [key: number]: string } = {};

  caisDetail: any = null;
  showCaisModal = false;
  loadingData = false;

  changeOrder() {
    this.pagination.total.reverse();
    this.resetPagination();
  }

  ngOnInit(): void {
    this.type = this.queryParamsService.getNumberParam(this.route, "type", 0);
    this.loadWarehouses();
    this.getProducts();
  }

  getProducts() {
    this.productService.getProductList().subscribe({
      next: (response: ResponseObject) => {
        this.productsIds = {}
        response.data.forEach(element => {
          this.productsIds[element.code] = element
        });
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  loadWarehouses() {
    this.warehouseService.getWarehouseByClue('').subscribe({
      next: (response: ResponseObject) => {
        this.warehouses = response.data;
        this.filterWarehouses = this.warehouses;
        this.warehouses.forEach((warehouse) => {
          this.warehousesById[warehouse.id] = warehouse.name.toLowerCase();
        });
        this.getPurchasesByIntervalDate();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  constructor(
    private toastService: ToastrService,
    private purchaseService: PurchasesService,
    private warehouseService: WarehouseService,
    private billToPayService: BillpayService,
    private productService: ProductService,
    private fiscalDocumentService: FiscalDocumentService,
    private caisService: CaisService,
    private route: ActivatedRoute,
    private queryParamsService: QueryParamsArService,
  ) {
    const today = new Date();
    this.startDate = this.queryParamsService.getStringParam(this.route, "startDate", getStringDate(today));
    this.endDate = this.queryParamsService.getStringParam(this.route, "endDate", getStringDate(today));
  }

  showModalSeries(invoice, productId) {
    this.newPurchaseSerie = new PurchaseSeriesRequest();
    this.newPurchaseSerie.providerInvoice = invoice.id;
    this.newPurchaseSerie.warehouseId = invoice.warehouse;
    this.newPurchaseSerie.productId = productId;
    this.productService.getAssociateSeriesPurchase(productId, invoice.id).subscribe({
      next: (response: ResponseObject) => {
        var actual_series = response.data as SeriesResponse[];
        actual_series.forEach((series) => {
          var seriesRequest = new SeriesRequest();
          seriesRequest.series = series.seriesProduct;
          seriesRequest.dataSeries = series;
          this.newPurchaseSerie.dataSeries.push(seriesRequest);
        })
        this.isModalSeriesShowed = true;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  closeModalSeries(element) {
    this.newPurchaseSerie = new PurchaseSeriesRequest();
    this.productToAddSerie = null;
    this.isModalSeriesShowed = false;
  }

  deleteInvoice(invoice: any) {
    this.waitingFor = invoice;
  }

  editInvoice(invoice: any) {
    this.newPurchase = invoice;
    this.purchaseService.getDetailInvoice(invoice).subscribe({
      next: (response: ResponseObject) => {
        this.newPurchase['detail'] = response.data;
        var tempDate = new Date(this.newPurchase.date);
        this.newPurchase.date = getStringDate(tempDate);
        this.editing = true;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al obtener el detalle de la factura");
      }
    })
  }

  confirmDelete(invoice: any) {
    if (this.deleting[invoice.id]) {
      return;
    }
    this.deleting[invoice.id] = true;
    this.waitingFor = null;

    if(invoice.isNcre!= null && invoice.isNcre == true){
      this.billToPayService.deleteNcre(invoice.id).subscribe({
        next: (response: ResponseObject) => {
          this.toastService.success("Se ha eliminado la nota de credito!");
          this.getPurchasesByIntervalDate();
          this.deleting = {}
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error("Error al eliminar la nota de credito");
          this.deleting = {}
        }
      });
    }else{
      this.purchaseService.deleteInvoice(invoice).subscribe({
        next: (response: ResponseObject) => {
          this.toastService.success("Se ha eliminado la factura!");
          this.getPurchasesByIntervalDate();
          this.deleting = {}
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error("Error al eliminar");
          this.deleting = {}
        }
      });
    }
  }

  resetDeletingDiv() {
    this.waitingFor = null;
  }

  convertToString(date: number) {
    if (!date) {
      return '';
    }
    var tempDate = new Date(date);
    return getStringDate(tempDate);
  }

  changeType() {
    const today = new Date();
    switch (parseInt(this.type + "")) {
      case 0:
        {
          this.endDate = getStringDate(today);
          this.startDate = getStringDate(today);
          break;
        }
      case 1:
        {
          this.endDate = getStringDate(today);
          today.setDate(today.getDate() - 7)
          this.startDate = getStringDate(today);
          break;
        }
      case 2:
        {
          this.endDate = getStringDate(today);
          today.setDate(1)
          this.startDate = getStringDate(today);
          break;
        }
      case 3:
        {
          const firstDayLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
          const lastDayLastMonth = new Date(today.getFullYear(), today.getMonth(), 0);

          this.startDate = getStringDate(firstDayLastMonth);
          this.endDate = getStringDate(lastDayLastMonth);
          break;
        }
      case 4:
        {
          this.endDate = getStringDate(today);
          today.setMonth(today.getMonth() - 2);
          this.startDate = getStringDate(today);
          break;
        }
      case 5:
        {
          this.endDate = getStringDate(today);
          today.setMonth(today.getMonth() - 3);
          this.startDate = getStringDate(today);
          break;
        }
    }
    this.queryParamsService.setParams(this.route, {
      type: this.type,
      startDate: this.startDate,
      endDate: this.endDate,
    });
    // this.getPurchasesByIntervalDate();
  }

  resetModalDetailAndMove() {
    this.invoiceDetail = null;
    this.isMoving = false;
    this.productToTransform = null;
    this.inputs.product = {
      value: null,
      verified: false,
      required: true,
      message: 'Campo requerido',
      class: 'fa-asterisk',
      color: 'danger',
      tooltip: 'status-warehouse',
      data: {
        id: null
      }
    };
    this.getPurchasesByIntervalDate();
  }

  addToQueueTransform(product: any) {
    if (this.productToTransform) {
      this.toastService.info("Termina de transformar un producto para continuar con el siguiente.");
      return;
    }
    if (this.products.length == 0) {
      this.gettingProducts[product.productData.id] = true;
      this.productService.getProducts("").subscribe({
        next: (response: ResponseObject) => {
          this.productToTransform = product;
          this.products = response.data.filter((product) => {
            return !product.code.includes("XML")
          });
          this.filterProducts = this.products;
          this.gettingProducts[product.productData.id] = false;
        },
        error: (error: HttpErrorResponse) => {
          this.gettingProducts[product.productData.id] = false;
          this.toastService.error(error.error.message);
        }
      })
    } else {
      this.productToTransform = product;
      this.filterProducts = this.products;
    }
  }

  writeProduct(input: any) {
    var inputValue = input.target.value;
    clearTimeout(this.timeout);
    this.inputs.product.class = "typing";
    this.timeout = setTimeout(() => {
      this.filterProducts = this.products.filter((product) => {
        return product.name.toLowerCase().includes(inputValue.toLowerCase())
          || (product.code + "").toLowerCase() == inputValue.toLowerCase() || (product.barCode && product.barCode == inputValue.toLowerCase())
      });
      this.inputs.product.verified = false;
      this.inputs.product.data = null;
      if (this.filterProducts.length == 0) {
        this.inputs.product.class = "fa fa-xmark";
      } else {
        this.inputs.product.class = "fa fa-list";
      }
    }, 400);
  }

  resetTransform() {
    this.inputs.product = {
      value: null,
      verified: false,
      required: true,
      message: 'Campo requerido',
      class: 'fa-asterisk',
      color: 'danger',
      tooltip: 'status-warehouse',
      data: {
        id: null
      }
    };
    this.productToTransform = null;
  }

  transform(quantity: number) {
    this.transforming = true;
    if (this.inputs.product.data.id != this.productToTransform.productData.id) {
      this.productService.transformProduct(
        this.productToTransform.productData.id, 
        this.inputs.product.data.id, 
        quantity, 
        this.warehouseId, 
        this.invoiceDetail.series, 
        this.invoiceDetail.number
      ).subscribe({
        next: (response: ResponseObject) => {
          this.productToTransform.productData.name = this.inputs.product.data['name'];
          this.productToTransform.productData.id = this.inputs.product.data.id;
          this.productToTransform.productData.idAssociated = this.inputs.product.data['code'];
          this.transforming = false;
          this.resetTransform();
          this.getPurchasesByIntervalDate();
          this.toastService.success("Se transformó correctamente el producto");
        },
        error: (error: HttpErrorResponse) => {
          this.transforming = false;
          this.warehouseId = 0;
          this.toastService.error(error.error.message);
        }
      })
    }
    else {
      this.transforming = false;
      this.toastService.info("Selecciona productos diferentes");
    }
  }

  selectProduct(product) {
    this.inputs.product.verified = true;
    this.inputs.product.data = product;
    this.inputs.product.class = "fa fa-circle-check";
    this.inputs.product.value = product.code + " - " + product.name;
  }

  getPurchasesByIntervalDate() {
    this.searchVendor = "";
    this.loadingData = true;
    this.purchaseService.getPurchasesByIntervalDate(getLongDate(this.startDate), getLongDate(this.endDate)).subscribe(
      {
        next: (response: ResponseObject) => {
          this.getNCRESByIntervalDate();
          this.purchases = response.data;
          this.total = 0;
          this.purchases.forEach((s) => {
            this.total += (s.totalCost + s.totalTaxes + s.extraTax);
            this.getTotalDetail(s);
          })
          this.purchases = this.purchases.sort((a, b) => {
            if (b.date !== a.date) {
              return b.date - a.date;
            } else {
              return b.id - a.id;
            }
          });
          if (this.isAscendent == 1) {
            this.purchases.reverse();
          }
          this.filterCheck();
          this.loadingData = false;
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error("Error al obtener las facturas");
          this.loadingData = false;
        }
      }
    );
  }

  // Trae las ncres
  getNCRESByIntervalDate() {
    this.searchVendor = "";
    this.billToPayService.getNCRESByDate(getLongDate(this.startDate), getLongDate(this.endDate), 0).subscribe({
      next: (response: ResponseObject) => {
        const ncreList = response.data;
        const ncrePurchases = ncreList.map(ncre => this.convertNCREToPurchase(ncre));
        this.purchases = this.purchases.concat(ncrePurchases);
        this.purchases = this.purchases.sort((a, b) => {
          if (b.date !== a.date) {
            return b.date - a.date;
          } else {
            return b.id - a.id;
          }
        });
        if (this.isAscendent == 1) {
          this.purchases.reverse();
        }
        this.filterCheck();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al obtener las notas de crédito");
      }
    });
  }




  getTotalDetail(purchase) {
    purchase['allAssociated'] = false;
    purchase['detail'] = null;
    this.detailing[purchase.id] = true;
    this.purchaseService.getDetailInvoice(purchase).subscribe(
      {
        next: (response: ResponseObject) => {
          var products = response.data;
          var total = 0;
          if (this.warehousesById[purchase.warehouse] != 'bodega por defecto') {
            products.forEach((product) => {
              var data = product.productData as ProductResponse;
              data.notAssociated = true;
              total += (data.idAssociated
                || (this.warehousesById[purchase.warehouse] != 'bodega por defecto' && !product.productData.code.includes('XML'))
                || !data.notAssociated) ? 1 : 0;
            });
          }
          if (total == products.length) {
            purchase['allAssociated'] = true;
          }
          purchase['detail'] = response.data;
          this.detailing[purchase.id] = false;
        },
        error: (error: HttpErrorResponse) => {
          this.detailing[purchase.id] = false;
          this.toastService.error("Error al obtener las facturas");
        }
      }
    );
  }

  getWarehouseName(idWarehouse: number) {
    for (let i = 0; i < this.warehouses.length; i++) {
      if (idWarehouse == this.warehouses[i].id) {
        return this.warehouses[i].name;
      }
    }
    return "";
  }

  changeDate() {
    if (this.startDate && this.endDate) {
      var tempStart = new Date(this.startDate);
      var tempEnd = new Date(this.endDate);
      if (tempStart > this.todayDate || tempEnd > this.todayDate) {
        this.toastService.info("No puedes ingresar fechas más allá del día de hoy");
      } else {
        if (tempStart > tempEnd) {
          this.toastService.info("La fecha de inicio debe ser más lejana que la de final");
        } else {
          this.queryParamsService.setParams(this.route, {
            type: this.type,
            startDate: this.startDate,
            endDate: this.endDate,
          });

          this.getPurchasesByIntervalDate();
        }
      }
    }
  }

  filterCheck() {
    this.pagination.total = this.purchases.filter((sale) => {
      if (this.warehouse != null) {
        if (this.warehouse != sale.warehouse) {
          return false;
        }
      }
      if (!this.invoiceCheck) {
        if (sale.invoice) {
          return false;
        }
      }
      if (!this.receiptCheck) {
        if (!sale.invoice) {
          return false;
        }
      }
      return true;
    });
    this.pagination.total = this.pagination.total.filter((sale) => {
      return sale.number == this.searchVendor || (sale.series ? sale.series : '').toLowerCase().includes(this.searchVendor.toLowerCase())
        || sale.providerData.name.toLowerCase().includes(this.searchVendor.toLowerCase()) || (sale.providerData.nit + "").toLowerCase().includes(this.searchVendor.toLowerCase());
    });
    this.total = 0;
    this.pagination.total.forEach((sale) => {
      this.total += (sale.totalCost + sale.totalTaxes + sale.extraTax);
    });
    this.resetPagination();
  }

  resetPagination() {
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.pageIndex = 0;
    this.pagination.lastElement = this.pagination.filter.length;
    this.pagination.startElement = 0;
  }

  searching() {
    this.filterCheck();
  }

  movingToWarehouse(invoice) {
    if (this.moving[invoice.id]) {
      return;
    }
    if (this.warehouses.length > 1) {
      this.isMoving = true;
      this.moving[invoice.id] = true;
      this.purchaseService.getDetailInvoice(invoice).subscribe({
        next: (response: ResponseObject) => {
          this.invoiceDetail = invoice;
          this.invoiceDetail['detail'] = response.data;
          var tempDate = new Date(this.invoiceDetail.date);
          this.invoiceDetail['dateString'] = getStringDate(tempDate);
          this.filterWarehouses = this.warehouses.filter((w) => {
            return w.id != this.invoiceDetail.warehouse;
          });
          if (this.filterWarehouses.length == 1) {
            this.inputs.warehouse.class = "fa-circle-check";
            this.inputs.warehouse.value = this.filterWarehouses[0].name;
            this.inputs.warehouse.verified = true;
            this.inputs.warehouse.data = this.filterWarehouses[0];
          }
          this.moving[invoice.id] = false;
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error("Error al obtener el detalle de la factura");
          this.moving[invoice.id] = false;
        }
      })
    } else {
      this.toastService.info("No existen más bodegas que la actual para hacer el traslado");
    }
  }

  detailingInvoice(invoice) {
    this.warehouseId = invoice.warehouse;
    if (this.detailing[invoice.id]) {
      return;
    }
    this.detailing[invoice.id] = true;
    if (invoice['detail']) {
      this.invoiceDetail = invoice;
      this.invoiceDetail['detail'] = invoice['detail'];
      var tempDate = new Date(this.invoiceDetail.date);
      this.invoiceDetail['dateString'] = getStringDate(tempDate);
      this.detailing[invoice.id] = false;
    } else {
      this.purchaseService.getDetailInvoice(invoice).subscribe({
        next: (response: ResponseObject) => {
          this.invoiceDetail = invoice;
          this.invoiceDetail['detail'] = response.data;
          var tempDate = new Date(this.invoiceDetail.date);
          this.invoiceDetail['dateString'] = getStringDate(tempDate);
          this.detailing[invoice.id] = false;
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error("Error al obtener el detalle de la factura");
          this.detailing[invoice.id] = false;
        }
      })
    }
  }

  verifiedInput(warehouseSelected: any) {
    var inputValue = warehouseSelected.target.value;
    clearTimeout(this.timeout);
    this.warehouseService.getWarehouseByClue(inputValue).subscribe({
      next: (response: ResponseObject) => {
        this.warehouses = response.data;
        this.filterWarehouses = this.warehouses.filter((w) => {
          return w.id != this.invoiceDetail.warehouse;
        });
        if (this.filterWarehouses.length == 1) {
          this.inputs.warehouse.class = "fa-check";
          this.inputs.warehouse.value = this.filterWarehouses[0].name;
          this.inputs.warehouse.verified = true;
          this.inputs.warehouse.data = this.filterWarehouses[0];
        } else {
          this.inputs.warehouse.class = "fa-xmark";
          this.inputs.warehouse.verified = false;
          this.inputs.warehouse.data = null;
        }
      },
      error: (error: HttpErrorResponse) => {
        this.inputs.warehouse.class = "fa-xmark";
        this.toastService.error(error.error.message);
        this.inputs.warehouse.verified = false;
        this.inputs.warehouse.data = null;
      }
    });
  }

  handleInput(warehouseSelected: any) {
    var inputValue = warehouseSelected.target.value;
    clearTimeout(this.timeout);
    this.inputs.warehouse.class = "typing";
    this.timeout = setTimeout(() => {
      this.warehouseService.getWarehouseByClue(inputValue).subscribe({
        next: (response: ResponseObject) => {
          this.warehouses = response.data;
          this.filterWarehouses = this.warehouses.filter((w) => {
            return w.id != this.invoiceDetail.warehouse;
          });
          if (this.filterWarehouses.length > 0) {
            this.inputs.warehouse.class = "bx bx-list-check";
            this.inputs.warehouse.verified = false;
            this.inputs.warehouse.data = null;
          } else {
            this.inputs.warehouse.class = "fa-xmark";
            this.inputs.warehouse.verified = false;
            this.inputs.warehouse.data = null;
          }
        },
        error: (error: HttpErrorResponse) => {
          this.inputs.warehouse.class = "fa-xmark";
          this.inputs.warehouse.verified = false;
          this.inputs.warehouse.data = null;
          this.toastService.error(error.error.message);
        }
      });
    }, 1000);
  }

  changeStatusInput(warehouseSelected: any) {
    this.inputs.warehouse.data = warehouseSelected;
    this.inputs.warehouse.value = warehouseSelected.name;
    this.inputs.warehouse.class = "fa-check";
    this.inputs.warehouse.verified = true;
  }

  confirmMovingToWarehouse() {
    if (this.moving[this.invoiceDetail.id]) {
      return;
    }
    this.moving[this.invoiceDetail.id] = true;
    var dataTransform: any = {};
    dataTransform.series = this.invoiceDetail.series;
    dataTransform.number = this.invoiceDetail.number;
    dataTransform.lot = this.invoiceDetail.lot;
    dataTransform.providerId = this.invoiceDetail.provider;
    dataTransform.sinceId = this.invoiceDetail.warehouse;
    dataTransform.towardsId = this.inputs.warehouse.data['id'];
    if (dataTransform.towardsId) {
      this.purchaseService.putMovingInvoice(this.invoiceDetail.id, dataTransform).subscribe({
        next: (response: ResponseObject) => {
          this.toastService.success("Se traslado correctamente la factura de compra!");
          this.inputs.warehouse = {
            value: null,
            verified: false,
            required: true,
            message: 'Campo requerido',
            class: 'fa-asterisk',
            color: 'danger',
            tooltip: 'status-warehouse',
            data: {
              id: null
            }
          };
          this.moving[this.invoiceDetail.id] = false;
          this.invoiceDetail = null;
          this.isMoving = false;
          this.getPurchasesByIntervalDate();
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error(error.error.message);
          this.moving[this.invoiceDetail.id] = false;
        }
      })
    } else {
      this.toastService.error("Ingresa una bodega/tienda destino");
    }
  }

  changeAssociated(productData) {
    var product = productData.productData;
    product.notAssociated = !product.notAssociated;
    this.productService.saveChanges(product.id, product).subscribe({
      next: (response: ResponseObject) => {
        if (product.notAssociated) {
          this.addToQueueTransform(productData);
        } else {
          this.productToTransform = null;
        }
        this.toastService.success("Se ha editado correctamente el producto");
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    });
  }

  private convertNCREToPurchase(ncre: any): PurchaseResponse {
    const purchase = new PurchaseResponse();
    purchase.id = ncre.id;
    purchase.series = ncre.series;
    purchase.number = ncre.document;
    purchase.date = ncre.date;
    purchase.accountingDate = ncre.date;
    purchase.provider = ncre.provider;
    purchase.providerData = null; // Completar si tienes acceso al vendor
    purchase.totalCost = ncre.amount; // negativo
    purchase.totalTaxes = 0; // puedes ajustar según tu lógica fiscal
    purchase.extraTax = 0; // idem
    purchase.invoice = false; // es nota de crédito
    purchase.currency = ncre.currency;
    purchase.company = ncre.company;
    purchase.warehouse = null; // depende de si tienes bodega asociada
    purchase.cancelled = false;
    purchase.cancelledDescription = '';
    purchase.description = ncre.description;
    purchase.taxPercentage = 0;
    purchase.exchangeRate = ncre.exchangeRate || 0;
    purchase.balance = ncre.balance || 0;
    purchase.discount = 0;
    purchase.hasIVA = false;
    purchase.hasISR = false;
    purchase.hasExemption = false;
    purchase.lot = null;
    purchase.user = ncre.createdBy;
    purchase.isNcre = true;
    const providerData = new VendorResponse();
    purchase.providerData = providerData;
    purchase.providerData.nit = ncre.nitProvider == null ? '' : ncre.nitProvider;
    purchase.providerData.name = ncre.nameProvider == null ? '' : ncre.nameProvider;
    return purchase;
  }

  generateFiscalDocument(invoice: any) {
    this.caisService.generateFiscalDocument(invoice.id).subscribe({
      next: (response: ResponseObject) => {

        if (response.success && response.data) {
          this.caisDetail = response.data;
          this.showCaisModal = true;
        }

        this.toastService.success("Documento fiscal encontrado");
      },
      error: (error: HttpErrorResponse) => {
        console.error(error);
        this.toastService.error("Error al buscar el documento fiscal");
      }
    });
  }

  closeCaisModal() {
    this.showCaisModal = false;
    this.caisDetail = null;
  }


}
